(() => {
  const SUPABASE_URL = 'https://axpdycqsactfwlvsqjim.supabase.co';
  const SUPABASE_KEY = 'sb_publishable_tvYS-vCTzIacRnhyH3FyFA_FU9G769L';
  const endpoint = SUPABASE_URL + '/rest/v1/sis_leads';

  const value = (form, name) => {
    const field = form.elements.namedItem(name);
    return field && typeof field.value === 'string' ? field.value.trim() : '';
  };

  const showStatus = (form, message, error) => {
    let status = form.querySelector('[data-sis-capture-status]');
    if (!status) {
      status = document.createElement('p');
      status.dataset.sisCaptureStatus = '';
      status.setAttribute('role', 'alert');
      form.prepend(status);
    }
    status.textContent = message;
    status.style.color = error ? '#a12626' : '#196b3a';
  };

  const capture = async (form, kind) => {
    const email = value(form, 'contact[email]');
    const name = kind === 'contact' ? value(form, 'contact[name]') : 'Newsletter subscriber';
    const details = kind === 'contact'
      ? value(form, 'contact[body]')
      : 'Opted in to receive occasional email updates from SIS Custom Creations.';
    const payload = {
      brand: 'SIS Custom Creations',
      offer_slug: kind === 'contact' ? 'contact' : 'newsletter',
      offer_name: kind === 'contact' ? 'Contact inquiry' : 'Newsletter signup',
      record_kind: 'lead',
      name: name || 'Website visitor',
      email,
      details: details || 'Website inquiry',
      source: kind === 'contact' ? 'shopify-contact' : 'shopify-newsletter',
      campaign: 'website',
      landing_page: window.location.href,
      page_title: document.title,
      status: 'new',
      payment_status: 'unpaid',
      raw_payload: {
        form: kind,
        marketing_consent: kind === 'newsletter',
        captured_by: 'sis-shopify-theme'
      }
    };

    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 7000);
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          apikey: SUPABASE_KEY,
          Authorization: 'Bearer ' + SUPABASE_KEY,
          'Content-Type': 'application/json',
          Prefer: 'return=minimal'
        },
        body: JSON.stringify(payload),
        signal: controller.signal,
        keepalive: true
      });
      if (!response.ok) throw new Error('intake request failed');
    } finally {
      window.clearTimeout(timeout);
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    const kind = form.id === 'SISContactForm'
      ? 'contact'
      : form.classList.contains('sis-newsletter__form') ? 'newsletter' : '';
    if (!kind || form.dataset.sisCaptureStarted === 'true') return;

    // Do not cancel Shopify's native submit: it performs CAPTCHA validation and
    // routes contact messages/customer subscriptions correctly.
    form.dataset.sisCaptureStarted = 'true';
    capture(form, kind).catch(() => {});
  });
})();

(() => {
  const button = document.querySelector('[data-menu-button]');
  const nav = document.querySelector('[data-mobile-nav]');
  if (!button || !nav) return;

  const setOpen = (open) => {
    nav.classList.toggle('is-open', open);
    button.setAttribute('aria-expanded', String(open));
  };

  button.addEventListener('click', () => {
    setOpen(!nav.classList.contains('is-open'));
  });

  nav.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => setOpen(false));
  });

  document.addEventListener('click', (event) => {
    if (!nav.classList.contains('is-open') || !(event.target instanceof Node)) return;
    if (!nav.contains(event.target) && !button.contains(event.target)) setOpen(false);
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 820) setOpen(false);
  });
})();